import React from "react";
import { ChatAvatar } from "./ChatAvatar";
import TileList from "./TileList";
import { Event, FormatDate } from "../../../models/Event";

interface SearchTileEventProps {
  event: Event;
  index: number;
  onTap: () => void;
  distance: string | null;
}

const SearchTileEvent: React.FC<SearchTileEventProps> = ({ event, index, onTap, distance }) => {
    return (
        <TileList 
            onTap={onTap}
            isSelected={false}
        >
            <div className="flex items-stretch">
                <div className="mr-2">
                <ChatAvatar 
                    event={event} 
                    loading={index < 15 ? 'eager' : 'lazy'}
                />
                </div>
                
                <div className="flex-1 mr-2 overflow-hidden">
                    <div className="flex flex-col ">
                        <div className="font-normal text-sm text-brand-orange">
                            {event.getDateFormatted(FormatDate.dateHour)}
                        </div>
                        <div
                            className={`break-words [word-wrap:anywhere] font-bold text-sm`}
                        >
                            {event.name}
                        </div>
                        <div
                            className={`font-normal text-sm truncate text-brand-grey`}
                        >
                            {event.address}
                        </div>
                    </div>
                </div>
            </div>
        </TileList>
    );
};

export default SearchTileEvent;